import BrButton from '@govbr/react-components/lib/BrButton';
import { useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import avisoIndicativoNascimento from '../../../assets/img/aviso-indicativo-nascimento.svg';
import { format, parseISO } from 'date-fns';
import { AcaoIndicativoNascimento } from '../../../api/indicativoNascimentoAPI';
import {
  registrarAcaoIndicativoNascimento,
  selectFamiliaIndicativoNascimento,
  selectIntegranteIndicativoNascimento,
  setEtapaIndicativo,
} from '../indicativoNascimentoSlice';
import ModalNaoIncluir from '../ModalNaoIncluir/ModalNaoIncluir';
import styles from './AvisoIndicativoNascimento.module.css';

const AvisoIndicativoNascimento: React.FC<{ onFechar: () => void }> = ({ onFechar }) => {
  const dispatch = useAppDispatch();
  const [modalNaoIncluir, setModalNaoIncluir] = useState(false);
  const [loadingNaoResponder, setLoadingNaoResponder] = useState(false);
  const [loadingNaoIncluir, setLoadingNaoIncluir] = useState(false);
  const integrante = useAppSelector(selectIntegranteIndicativoNascimento);
  const familia = useAppSelector(selectFamiliaIndicativoNascimento);

  const nomeCompleto = integrante?.nome ?? '';
  const dataNascimento = integrante?.dataNascimento
    ? format(parseISO(integrante.dataNascimento), 'dd/MM/yyyy')
    : '';

  const despacharAcao = (codigoAcao: AcaoIndicativoNascimento) => {
    if (familia?.nuFamiliar && integrante?.cpf) {
      return dispatch(registrarAcaoIndicativoNascimento({
        numeroFamiliar: familia.nuFamiliar,
        cpfIntegrante: integrante.cpf,
        codigoAcao,
      }));
    }
  };

  const handleNaoIncluir = async () => {
    setLoadingNaoIncluir(true);
    await despacharAcao(AcaoIndicativoNascimento.NAO_DESEJA_INCLUIR);
    setLoadingNaoIncluir(false);
    setModalNaoIncluir(false);
    dispatch(setEtapaIndicativo('compareca-ao-cras'));
  };

  const handleNaoResponderAgora = async () => {
    setLoadingNaoResponder(true);
    await despacharAcao(AcaoIndicativoNascimento.INCLUSAO_OUTRO_MOMENTO);
    setLoadingNaoResponder(false);
    onFechar();
  };

  return (
    <div className={styles.container}>
      <div className={styles.imagemWrapper}>
        <img
          className={styles.imagem}
          src={avisoIndicativoNascimento}
          alt="Indicativo de nascimento"
        />
      </div>
      <div className={styles.conteudo}>
        <div className={styles.texto}>
          Detectamos novo(a) integrante na sua família.
          <br />
          <br />
          Você quer incluir <strong>{nomeCompleto}</strong>, que nasceu em{' '}
          <strong>{dataNascimento}</strong>, como integrante da sua família no Cadastro Único?
        </div>
        <BrButton className={styles.botaoSim} onClick={() => dispatch(setEtapaIndicativo('confirmacao'))}>
          Sim, quero incluir
        </BrButton>
        <BrButton className={styles.botaoNao} onClick={() => setModalNaoIncluir(true)}>
          Não quero incluir
        </BrButton>
        <p className={styles.aviso}>
          Caso não inclua, o Responsável Familiar (RF) deverá comparecer ao CRAS para atualização cadastral.
        </p>
        <button className={styles.linkResponder} onClick={handleNaoResponderAgora} disabled={loadingNaoResponder}>
          {loadingNaoResponder ? <div className="loading small"></div> : 'Não quero responder agora'}
        </button>
      </div>
      <ModalNaoIncluir
        open={modalNaoIncluir}
        nomeIntegrante={nomeCompleto}
        loadingNaoIncluir={loadingNaoIncluir}
        onContinuar={() => { setModalNaoIncluir(false); dispatch(setEtapaIndicativo('confirmacao')); }}
        onNaoIncluir={handleNaoIncluir}
      />
    </div>
  );
};

export default AvisoIndicativoNascimento;
